"use client";

import { useConfig } from "@jti/app-context/useConfig";

import { RegionSelectorRenderer } from "./RegionSelectorRenderer";

export function RegionSelector({ selectedRegion }: { selectedRegion: string }) {
  const { regionSelector } = useConfig();
  const { isRegionSelectorEnabled, regionOptions } = regionSelector;

  if (!isRegionSelectorEnabled || regionOptions.length === 0) {
    return null;
  }

  return <RegionSelectorRenderer regionOptions={regionOptions} selectedRegion={selectedRegion} />;
}
